import React from 'react';

import {DetailPagePermissionsSidebar} from 'app/components/general/DetailPagePermissionsSidebar/DetailPagePermissionsSidebar';
import {SidebarItem} from 'app/general/structures/SidebarItem';
import {getObjectPermissionsURL} from 'app/urls';
import {gt} from 'app/utils/i18n';

import type {
  LeftSidebarElementType,
  LeftSidebarMenuButton,
  LeftSidebarPanelType,
} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {DetailPageItemType} from 'app/components/general/DetailPage/types';

function PermissionsPanelContent<ItemType extends DetailPageItemType>({
  object,
}: LeftSidebarPanelType<ItemType>) {
  return (
    <DetailPagePermissionsSidebar
      title={gt('Permissions')}
      objectId={object.id}
      closeUrl={object.html_url}
      contentType={object.content_type}
      documentUrl={object.url}
      showExportButton={object.can_edit}
    />
  );
}

function PermissionsMenuButton<ItemType extends DetailPageItemType>({
  object,
  forceTooltipShow,
  hideTooltip,
  location,
  active,
}: LeftSidebarMenuButton<ItemType>) {
  return (
    <SidebarItem
      title={gt('Permissions')}
      active={active}
      icon="fa fa-lock"
      link={getObjectPermissionsURL(object, location.search)}
      forceTooltipShow={forceTooltipShow}
      onClick={hideTooltip}
    />
  );
}

export const PermissionsSidebar: LeftSidebarElementType<DetailPageItemType> = {
  Panel: PermissionsPanelContent,
  MenuButton: PermissionsMenuButton,
  type: 'left',
  sidebarName: 'showPermissions',
};
